<!-- git/truth-first-look/src/components/dashboard/MediaGrid.tsx -->
<ng-container *ngIf="media?.length">
  <div *ngIf="count() === 1" class="rounded-2xl overflow-hidden border border-border mt-3 max-h-[400px]">
    <div class="relative overflow-hidden bg-muted/30 cursor-pointer group w-full h-full max-h-[400px]">
      <img [src]="imgSrc(media[0])" alt="" class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.03]" loading="lazy" />
      <ng-container *ngIf="media[0].type === 'video'">
        <div class="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/30 transition-colors">
          <div class="w-12 h-12 rounded-full bg-black/60 backdrop-blur-sm flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" class="text-white ml-0.5">
              <polygon points="5 3 19 12 5 21 5 3" />
            </svg>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div *ngIf="count() === 2" class="rounded-2xl overflow-hidden border border-border mt-3 grid grid-cols-2 gap-0.5 max-h-[300px]">
    <div *ngFor="let item of sliceMedia(); let i = index" class="relative overflow-hidden bg-muted/30 cursor-pointer group h-[300px]">
      <img [src]="imgSrc(item)" alt="" class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.03]" loading="lazy" />
      <ng-container *ngIf="item.type === 'video'">
        <div class="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/30 transition-colors">
          <div class="w-12 h-12 rounded-full bg-black/60 backdrop-blur-sm flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" class="text-white ml-0.5">
              <polygon points="5 3 19 12 5 21 5 3" />
            </svg>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div *ngIf="count() === 3" class="rounded-2xl overflow-hidden border border-border mt-3 grid grid-cols-2 gap-0.5 max-h-[300px]">
    <div class="row-span-2">
      <div class="relative overflow-hidden bg-muted/30 cursor-pointer group h-[300px]">
        <img [src]="imgSrc(media[0])" alt="" class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.03]" loading="lazy" />
        <ng-container *ngIf="media[0].type === 'video'">
          <div class="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/30 transition-colors">
            <div class="w-12 h-12 rounded-full bg-black/60 backdrop-blur-sm flex items-center justify-center">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" class="text-white ml-0.5">
                <polygon points="5 3 19 12 5 21 5 3" />
              </svg>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="flex flex-col gap-0.5">
      <div *ngFor="let item of media.slice(1, 3)" class="relative overflow-hidden bg-muted/30 cursor-pointer group h-[149px]">
        <img [src]="imgSrc(item)" alt="" class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.03]" loading="lazy" />
        <ng-container *ngIf="item.type === 'video'">
          <div class="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/30 transition-colors">
            <div class="w-12 h-12 rounded-full bg-black/60 backdrop-blur-sm flex items-center justify-center">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" class="text-white ml-0.5">
                <polygon points="5 3 19 12 5 21 5 3" />
              </svg>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <div *ngIf="count() >= 4" class="rounded-2xl overflow-hidden border border-border mt-3 grid grid-cols-2 gap-0.5 max-h-[300px]">
    <div *ngFor="let item of sliceMedia()" class="relative overflow-hidden bg-muted/30 cursor-pointer group h-[149px]">
      <img [src]="imgSrc(item)" alt="" class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.03]" loading="lazy" />
      <ng-container *ngIf="item.type === 'video'">
        <div class="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/30 transition-colors">
          <div class="w-12 h-12 rounded-full bg-black/60 backdrop-blur-sm flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" class="text-white ml-0.5">
              <polygon points="5 3 19 12 5 21 5 3" />
            </svg>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
